import api from "axios";

export const billetDiscount = async (id_avaliacao) => {
  return api
    .post(`/purchasers/wallet/executePayment/${id_avaliacao}`)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const checkPayment = async (id_avaliacao) => {
  return api
    .get(`/purchasers/wallet/checkPayment/${id_avaliacao}`)
    .then((response) => response.data.payload)
    .catch((error) => error);
};
